<dx-grid mq1="12/*">
  @if (showDragAndDrop() || imageUrl() === null || imageUrl() === undefined) {
    <art-drag-and-drop
      (uploadedImage)="uploadImage($event)"
      [showError]="imageError()"
      [errorMessage]="errorMessage()"
    ></art-drag-and-drop>
    @if (imageUrl()) {
      <art-button
        class="image-change-button"
        label="{{ 'dropzone.button.cancel-image-upload' | transloco }}"
        shape="link"
        (click)="cancelImageUpload()"
        icon="cancel"
      ></art-button>
    }
  } @else {
    <art-bordered-image [uploadedImageUrl]="imageUrl()" [altText]="altText()"></art-bordered-image>
    <art-button
      class="image-change-button"
      label="{{ 'dropzone.button.change-image' | transloco }}"
      shape="link"
      (click)="showImageUpload()"
      icon="change_circle"
    ></art-button>
  }
</dx-grid>
